/* eslint-disable no-undef */
import Api from '@/services/Api'

export default {
  fileStatus (fileId, unitId, docType) {
    const params = {
      fileId: fileId,
      unitId: unitId,
      docType: docType
    }
    return Api().get('filestatus', {params: params})
  },
  inputfiledetails (params) {
    return Api().get('inputfiledetails', {params: params})
  },
  inputFileSaveRowDetails (fileId, rowData) {
    return Api().post('inputfilesaverowdetails', {fileId: fileId, rowData: rowData})
  }
}



// WEBPACK FOOTER //
// ./src/services/InputFile.js